import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { AuthUser, Company } from "../lib/types";
import { authStorage } from "../services/auth-storage";

type StoreState = {
  authUser: AuthUser | null;
  selectedCompany: Company | null;
}

export interface Store extends StoreState {
  authUser: AuthUser | null;
  selectedCompany: Company | null;
  isOnline: boolean;
  logoBase64: string | null;
  setAuthUser: (user: AuthUser | null) => void;
  setSelectedCompany: (company: Company | null) => void;
  setIsOnline: (value: boolean) => void;
  setLogoBase64: (value: string | null) => void;
  logout: () => void;
}

const useStore = create<Store>()(
  persist(
    (set) => ({
      authUser: null,
      selectedCompany: null,
      isOnline: navigator.onLine,
      logoBase64: null,
      setAuthUser: (user) => set({ authUser: user }),
      setSelectedCompany: (company) => set({ selectedCompany: company }),
      setIsOnline: (value) => set({ isOnline: value }),
      setLogoBase64: (value) => set({ logoBase64: value }),
      logout: () => {
        authStorage.clearCredentials();
        localStorage.removeItem('auth');
        set({ authUser: null, selectedCompany: null });
      },
    }),
    {
      name: "playbpo-storage",
      version: 1,
      storage: createJSONStorage(() => localStorage),
      partialize: (state): StoreState => ({ 
        authUser: state.authUser,
        selectedCompany: state.selectedCompany 
      }),
    }
  )
);

export default useStore;
